// Arabic language file
export const AR = {
  preparing_zip: "جارٍ تحضير الملف المضغوط…",
  compressing: "جارٍ الضغط…",
  info_icon: "بمجرد وضع علامة كمكتمل، لن يتمكن أعضاء إضافيون من الانضمام أو الإضافة، وسيتم إلغاء تفعيل جميع مجموعات الدردشة. يرجى ملاحظة أن المشروع، مع جميع مجموعات الدردشة والبيانات، سيبقى قابلاً للوصول في حالة غير مفعلة.",
  mark_is_done: "هل أنت متأكد أنك تريد وضع علامة على المشروع كمكتمل؟ بمجرد وضع العلامة، لن يتمكن أعضاء إضافيون من الانضمام أو الإضافة، وسيتم إلغاء تفعيل جميع مجموعات الدردشة. يرجى ملاحظة أن المشروع، مع جميع مجموعات الدردشة والبيانات، سيبقى قابلاً للوصول في حالة غير مفعلة.",
  mark_not_done: "هل أنت متأكد أنك تريد إعادة فتح المشروع؟ بمجرد وضع علامة كمفتوح، يمكن لأعضاء إضافيين الانضمام أو الإضافة، وسيتم إعادة تفعيل جميع مجموعات الدردشة.",
  mark_as_completed: "وضع علامة على المشروع كمكتمل",
  room_completed: "المشروع مكتمل",
  room_members: "أعضاء المشروع",
  deactivated_rooms: "المشاريع المعطلة",
  deactivated_chats: "الدردشات المعطلة",
  completed_rooms: "المشاريع المكتملة",
  request_to_join_a_room: 'طلب الانضمام إلى المشروع',
  wants_to_rejoin_room: 'Username يريد الانضمام مجدداً إلى المشروع Roomname.',
  invited_you_to_join_room: 'Username دعاك للانضمام إلى المشروع Roomname.',
  restart: "إعادة التشغيل",
  update_text: "تحديث جديد متاح. انقر على إعادة التشغيل لتثبيت التحديث.",
  update_availble: "تحديث متاح",
  Loading: "جاري التحميل...",
  logout: "تسجيل الخروج",
  back: 'رجوع',
  company_list: "قائمة الشركات",
  followers: "المتابعون",
  followings: "المتابعات",
  article: "مقال",
  companies: "الشركات",
  one_to_one_chat: " دردشة فردية",
  profile: "الملف الشخصي",
  company: "الشركة",
  company_selection: "اختيار الشركة",
  home: "الرئيسية",
  contact: "اتصال ",
  add_company: "إضافة شركة ",
  add_project: "إضافة مشروع ",
  capacities: "القدرات ",
  work_area: "منطقة العمل",
  company_services: "خدمات الشركة",
  website: "الموقع الإلكتروني",
  search_contacts: "البحث عن جهات الاتصال",
  add_or_join_a_company: "إضافة أو الانضمام إلى شركة",
  follow: "متابعة",
  following: "متابع",
  like: "إعجاب",
  company_contacts: "جهة اتصال الشركة",
  leave_the_company: "مغادرة الشركة",
  news: "الأخبار",
  earlier: "سابقاً",
  action: "إجراء",
  another_action: "إجراء آخر",
  something_else: "شيء آخر",
  search: "بحث",
  search_rooms: "البحث عن المشاريع",
  search_articles: "البحث عن المقالات",
  contacts: "جهات الاتصال",
  suggestions: "اقتراحات",
  project_list: "قائمة المشاريع",
  search_results: "نتائج البحث",
  add_or_join_project: "إضافة أو الانضمام إلى مشروع",
  details: "التفاصيل",
  your_position_within_company: "يرجى اختيار منصبك داخل الشركة.",
  close_modal: "إغلاق",
  map: "الخريطة",
  or: "أو",
  name: "الاسم*",
  street: "الشارع*",
  house_number: "رقم المنزل",
  postal_code: "الرمز البريدي",
  city: "المدينة*",
  opened_by: "تم الفتح بواسطة:",
  project_No: "رقم المشروع: ",
  building_type: "نوع المبنى*",
  building_types: "نوع المبنى",
  add_join: "إضافة/انضمام",
  mandatory_fiels: "*الحقول الإلزامية",
  invalid_fiels: "هذا الحقل مطلوب",
  add_or_join_company: "إضافة أو الانضمام إلى شركة",
  name_of_the_company: "اسم الشركة",
  edit_company_details: "تعديل تفاصيل الشركة",
  branch_of_the_building_industry: "فرع صناعة البناء",
  corporate_form: "الشكل القانوني",
  position_within_company: "المنصب داخل الشركة",
  request_confirmation: "طلبات المشاريع المعلقة",
  company_e_mail: "البريد الإلكتروني للشركة",
  type_of_filter: "اكتب للتصفية...",
  setting: "الإعداد",
  dashboard: "لوحة التحكم",
  settings: "الإعدادات",
  views: "المشاهدات",
  times_seen: "مرة شوهد",
  see_more: "...المزيد",
  see_less: "...أقل",
  in_search: "في البحث",
  reset_password: "إعادة تعيين كلمة المرور",
  submit: "إرسال",
  password: "كلمة المرور",
  email: "البريد الإلكتروني",
  confirm_password: "تأكيد كلمة المرور",
  reset_email: "إعادة تعيين البريد الإلكتروني",
  update: "تحديث",
  new_email: "بريد إلكتروني جديد",
  kjuup_message: "رسالة Kjuup",
  delete_profile: "حذف الملف الشخصي؟",
  my_position: "منصبي:",
  add: "إضافة",
  owner_company_admin: "مدير الشركة:",
  owner_company_admin_new: "مدير الشركة",
  mutual_contact: "جهة اتصال مشتركة",
  mutual_contacts: "جهات اتصال مشتركة",
  co_owner: "شريك",
  managing_director: "المدير التنفيذي",
  associate: "شريك",
  secretary: "سكرتير",
  employee: "موظف",
  project_manage: "مدير المشروع",
  auto_chat_translation: "الترجمة التلقائية للدردشة",
  translate_room_group_names: "ترجمة أسماء مجموعات الدردشة",
  translate_room_group_names_info: "عند التفعيل، تُترجم أسماء مجموعات الدردشة تلقائيًا إلى لغة الواجهة.",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "عند التفعيل، سيتم فتح علامة تبويب البريد الإلكتروني بشكل افتراضي بدلاً من الرسائل عند فتح التطبيق.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "اللغة",
  english: "الإنجليزية",
  german: "الألمانية",
  french: "الفرنسية",
  italian: "الإيطالية",
  change_language: "تغيير اللغة",
  my_companies: "شركاتي",
  employees: "الموظفون",
  invite_with_a: "دعوة إلى Kjuup",
  add_member: "إضافة عضو",
  add_user: "إضافة مستخدم",
  send_location: "إرسال الموقع",
  assign_admin_rights: "تعديل صلاحيات المدير",
  deactivate_company: "إلغاء تفعيل الشركة",
  remove_employees: "إزالة الموظفين",
  remove_members: "إزالة الأعضاء",
  no_user_found: "لم يتم العثور على مستخدم!",
  approve: "الموافقة!",
  deselect_all: "إلغاء تحديد الكل",
  select_all: "تحديد الكل",
  translation_on_building_projects: "الترجمة في المشاريع",
  reported_capacities: "الخدمات المبلغ عنها",
  up_to_50m_exact: "حتى 50 متر بالضبط",
  company_details_service: "خدمات الشركة",
  company_contact: "جهة اتصال الشركة",
  invite_with_link: "دعوة إلى Kjuup",
  share_link: "مشاركة الرابط",
  share_company_link: "مشاركة الرابط",
  qr_code: "رمز QR",
  copy_link: "نسخ الرابط",
  cancel_link: "إلغاء الرابط",
  who_has_confirmed_services: "من أكد خدماتك؟",
  projectss: "المشاريع",
  add_services: "إضافة الخدمات",
  services: "الخدمات",
  save_text: "حفظ",
  share_on: "مشاركة على:",
  articlen: "مقال",
  invite_user_to_confirm_service: "دعوة المستخدمين لتأكيد الخدمات للشركة.",
  link_copied: "تم نسخ الرابط!",
  email_copied: "تم نسخ البريد الإلكتروني!",
  personal_article: "مقال شخصي",
  company_article: "مقال الشركة",
  characters_remaining: "الأحرف المتبقية",
  optional_information: "معلومات اختيارية",
  project: "المشروع",
  projects: "المشاريع...",
  abort: "تجاهل",
  preview: "معاينة",
  post: "نشر",
  of: "من",
  remove: "إزالة",
  free_capacity: "بوابة الوظائف",
  current_status_overview: "نظرة عامة على الحالة الحالية",
  report_capacities: "الإبلاغ عن الخدمات",
  report_text: "تقرير",
  search_capacities: "العثور على المقاولين",
  add_project_user: "إضافة مستخدم المشروع",
  media: "الوسائط",
  links: "الروابط",
  docs: "المستندات",
  featured_products: "المنتجات المميزة...",
  title: "العنوان",
  text: "النص",
  feed_details: "تفاصيل الخلاصة",
  add_employee: "إضافة موظف",
  latest: "الأحدث",
  my_projects: "مشاريعي",
  cancel: "إلغاء",
  continue: "متابعة",
  role_in_the_building_industry: "الدور في صناعة البناء",
  als: "كـ",
  join: "انضمام",
  find: "البحث",
  request_to_join_a_company: "طلب الانضمام إلى الشركة",
  wants_to_join_the_company: "يريد الانضمام إلى الشركة",
  filter_by: "تصفية حسب",
  ok: "موافق",
  close: "إغلاق",
  weekly_statistics: "الإحصائيات الأسبوعية",
  is_following_you: "يتابعك.",
  as: "كـ",
  has_joined_the: "انضم إلى الشركة",
  has_looked_at_your_profile: "نظر إلى ملفك الشخصي.",
  time: "الوقت",
  in_searches_in_past_week: "في عمليات البحث في الأسبوع الماضي.",
  has_liked_your_article: "أعجب بمقالك.",
  has_published_a_new_article: "نشر مقالاً جديداً.",
  you: "أنت",
  all_views: "جميع المشاهدات",
  all_profile_views: "جميع مشاهدات الملف الشخصي",
  mutual_company: "شركة مشتركة",
  artical_text: "كتابة مقال...",
  you_have_appeared: "لقد ظهرت",
  your_request_at_the_company: "طلبك في الشركة",
  times_you_have_appeared_in_searches: "مرة ظهرت في عمليات البحث",
  appear_more_often_in_searches: "الظهور في عمليات البحث بشكل أكثر تكراراً",
  you_have_been_found: "تم العثور عليك",
  improve_profile: "تحسين الملف الشخصي",
  choose_existing_contact_for_single_chat: "اختر جهة اتصال موجودة للدردشة الفردية:",
  in_order_to_add_new_contacts: "لإضافة جهات اتصال جديدة، يرجى البحث عن جهات اتصال جديدة في صفحة الملف الشخصي.",
  times_in_searches_in_the_last_week: "مرة في عمليات البحث في الأسبوع الماضي. قم بتحديث ملفك الشخصي وأضف المزيد من التفاصيل لتسهيل العثور عليك.",
  has_been_confirmed: "تم التأكيد.",
  have_joined_the: "انضموا إلى ",
  building_project: " مشروع البناء.",
  select_with_which_company_you_want_to_connect_to_the_project: "اختر الشركة التي ستمثلها. سيتم عرض هذا للمشاركين الآخرين.",
  select_with_which_company_you_want_to_connect_to_the_chat: "اختر الشركة التي ستمثلها. سيتم عرض هذا للمشاركين الآخرين.",
  select_internal_section: "يرجى اختيار القسم الداخلي",
  select_profile_image: "اختر صورة الملف الشخصي",
  share_user: "مشاركة المستخدم",
  contact_sender_message: "شارك هذا الرابط لدعوة عضو غير مسجل في Kjuup إلى Kjuup. يمكن استخدام هذا الرابط من قبل عدة أشخاص للتسجيل.",
  project_sender_message: "شارك هذا الرابط لدعوة عضو غير مسجل في Kjuup إلى مشروع اسم المشروع. يمكن استخدام هذا الرابط من قبل عدة أشخاص للتسجيل والانضمام إلى مشروع اسم المشروع في Kjuup.",
  company_sender_message: "شارك هذا الرابط لدعوة عضو غير مسجل في Kjuup إلى شركة اسم الشركة. يمكن استخدام هذا الرابط من قبل عدة أشخاص للتسجيل والانضمام إلى الشركة في Kjuup.",
  contact_receivers_message: "رابط دعوة للانضمام إلى Kjuup. يرجى النقر على الرابط للتسجيل في kjuup.",
  iphone: "iPhone:",
  iphone_recivers_message: "في حالة تثبيت Kjuup عبر متجر تطبيقات Apple، يجب النقر على هذا الرابط بعد التحميل الناجح، لتتمكن من التسجيل.",
  project_receivers_message: "رابط دعوة للانضمام إلى مشروع اسم المشروع في Kjuup. يرجى النقر على الرابط للتسجيل في Kjuup والانضمام إلى مشروع اسم المشروع.",
  company_receivers_message: "رابط دعوة إلى شركة اسم الشركة في Kjuup. يرجى النقر على الرابط للتسجيل في Kjuup والانضمام إلى شركة اسم الشركة.",
  sign_in: "تسجيل الدخول",
  enter_your_email_add: "أدخل عنوان بريدك الإلكتروني",
  forgot_password: "نسيت كلمة المرور",
  dont_have_account: "ليس لديك حساب؟",
  register: "التسجيل",
  get_app: "احصل على التطبيق",
  registration: "التسجيل",
  dep_ing: "Dipl.-Ing.",
  dr: "د.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Architect",
  prof: "أ.د.",
  first_name: "الاسم الأول",
  last_name: "اسم العائلة",
  have_an_account: "لديك حساب؟",
  when_register_you_agree: "عند التسجيل أنت توافق على",
  term_of_use: "شروط الاستخدام",
  to: "إلى.",
  in_our: "في",
  data_policy: "سياسات البيانات",
  they_find_out: "يكتشفون،",
  we_provide_store_data: "كيف نجمع ونعالج ونخزن المعلومات.",
  leaving_company_text: "هل تريد حقاً مغادرة الشركة؟ عند مغادرة الشركة، ستغادر أيضاً جميع المشاريع ومجموعات الدردشة المرتبطة. يمكنك إعادة الانضمام إلى هذه المشاريع مع شركة أخرى في أي وقت.",
  delete_profile_text: "هل تريد حقاً حذف ملفك الشخصي؟ عند حذف ملفك الشخصي، سيتم إزالة جميع الاتصالات بالشركات والمشاريع والدردشات. يمكنك إنشاء ملف شخصي جديد في أي وقت.",
  confirm: "تأكيد",
  reject: "رفض",
  requet_to_leave: "طلب المغادرة",
  choose: "اختيار",
  your_add_member: "إضافة عضو",
  if_you: "في حالة",
  can_not_find: "لا يمكن العثور على جهة اتصالك هنا.",
  please_wait: "يرجى الانتظار..",
  imprint_gtc: "الطابع/الشروط والأحكام",
  register_confirm_popup: "يرجى التحقق من بريد Kjuup الإلكتروني قبل تسجيل الدخول. لقد أرسلنا رابط تأكيد إلى صندوق الوارد. إذا لم تجده، تحقق أيضاً من مجلد البريد العشوائي.",
  PENDING_GROUP_USER: "سيستلم الرسائل فقط بعد تأكيد الدعوة إلى المشروع. ستظهر رسالة إضافية بمجرد تأكيد الدعوة إلى المشروع.",
  PENDING: "تأكيد الدعوة إلى المشروع معلق",
  denied_group_chat: " رفض دعوة المشروع وغادر هذه المجموعة.",
  joined_group_chat: " انضم إلى هذه المجموعة",
  you_joined_group_chat: "انضممت إلى هذه المجموعة.",
  Others: "آخرون",
  LEFT_GROUP: "غادر مجموعة الدردشة هذه.",
  YOU_LEFT_GROUP: "غادرت مجموعة الدردشة هذه.",
  days: "أيام",
  day: "يوم",
  hour: "ساعة",
  hide_project: "إخفاء المشروع",
  hide_project_popup_text: "إذا قمت بإخفاء المشاريع، فلن يمكن العثور عليها داخل Kjuup. فقط أعضاء المشروع يمكنهم دعوة مستخدمين جدد إلى المشروع.",
  branch: "الفرع",
  photo_video_media_lib: "مكتبة الوسائط - الصور والفيديو",
  document: "مستند",
  location_meeting: "الموقع / الاجتماع",
  all_member_of_project: "جميع أعضاء المشروع",
  pending_request: "طلبات المشاريع المعلقة",
  no_pending_request: "لم يتم العثور على طلبات معلقة!",
  news_feed: "خلاصة الأخبار",
  user_info: "معلومات المجموعة",
  leave_project: "مغادرة المشروع",
  media_link_docs: "الملفات",
  search_chat: "البحث في الدردشة",
  export_chat_group: "تصدير بيانات مجموعة الدردشة من الشهر الماضي",
  request_complete_chat_history: "طلب سجل الدردشة الكامل",
  leave_chat_group: "مغادرة مجموعة الدردشة",
  add_user_project: "إضافة مستخدم",
  me: "أنا",
  max_open_one_to_one: "حالياً يمكن فتح حد أقصى 2 دردشة فردية بالتوازي في القسم السفلي والعلوي. إجمالاً يمكن فتح حد أقصى 4 دردشات فردية.",
  are_you_sure_you_want_leave_chat: "هل أنت متأكد أنك تريد مغادرة مجموعة الدردشة هذه؟",
  create_group: "إنشاء مجموعة",
  adding_members: "...جارٍ إضافة الأعضاء",
  creating_the_chat: "...جارٍ إنشاء المحادثة",
  finishing_setup: "...جارٍ الإنهاء",
  group_name: "اسم المجموعة",
  by: "بواسطة:",
  mandetory: "*إلزامي",
  delteed: "حذف ملفه الشخصي وغادر دردشة المجموعة.",
  deleted_direct: "حذف ملفه الشخصي وغادر الدردشة.",
  unhidden_message: "إذا قمت بإلغاء إخفاء المشاريع، يمكن لجميع أعضاء Kjuup العثور عليها.",
  account_deleted: "تم حذف الحساب.",
  refuse_company: "هل أنت متأكد أنك تريد رفض دعوة الشركة؟",
  follow_additional: "متابعة مستخدمين إضافيين",
  f_add: "تابع مستخدمين إضافيين من Kjuup لجعلهم متاحين للرسائل المباشرة.",
  c_inv: "دعوة/دعوات الشركة",
  invited_o_Company: "تمت دعوتك للانضمام إلى الشركة",
  refuse_companyX: "هل أنت متأكد أنك تريد رفض طلب الشركة؟",
  a_Da: "تم إلغاء تفعيل الحساب.",
  has_deactivated: "ألغى تفعيل ملفه الشخصي.",
  reactive: "أعاد تفعيل ملفه الشخصي.",
  juup_note: "*التسجيل باسم المستخدم متاح فقط لأعضاء Kjuup+",
  username: "اسم المستخدم*",
  email_username: "البريد الإلكتروني/اسم المستخدم*",
  sPinText: "يرجى تقديم رمز PIN أمني مكون من 6 أرقام. سيكون هذا الرمز مطلوباً في حالة نسيان كلمة المرور وهو إلزامي لتأكيد حسابك.",
  DeleteKjuupPlusText: "هل تريد حقاً حذف ملفك الشخصي؟ عند حذف ملفك الشخصي، سيتم إزالة جميع الاتصالات بالشركات والمشاريع والدردشات.\n\nخلال 48 ساعة بعد حذف الحساب، يمكنك إعادة تفعيل حسابك بتسجيل الدخول باسم المستخدم وكلمة المرور ورمز PIN.",
  reactive_text: "تم حذف حسابك. يرجى النقر على إعادة التفعيل لإعادة تفعيل حسابك.",
  rac: "إعادة التفعيل",
  ac_ss: "تم إعادة تفعيل الحساب بنجاح.",
  not_valid_pin: "رمز PIN غير صالح",
  only_for_kjuup: "*إعادة تعيين كلمة المرور عبر اسم المستخدم ورمز PIN متاح فقط لأعضاء Kjuup+.",
  resetPIN: "إعادة تعيين PIN",
  enter_current_pin: "يرجى إدخال رمز PIN الحالي",
  enter_new: "إدخال رمز PIN جديد",
  pin_to_confirm: "يرجى تقديم رمز PIN للتأكيد.",
  change_username: "إعادة تعيين اسم المستخدم",
  pp_not_match: "كلمة المرور - وتأكيد كلمة المرور غير متطابقين",
  reactive_itself: "لقد أعدت تفعيل ملفك الشخصي.",
  has_deactivated_itself: "لقد ألغيت تفعيل ملفك الشخصي.",
  more_than_two: "حالياً يمكن إجراء الرسائل المباشرة فقط مع مستخدمين في نفس الوقت.",
  Chats: "الرسائل المباشرة",
  only_in_mobileL: "يمكن حالياً رفع ونشر مقاطع الفيديو الأصلية فقط عبر تطبيق الهاتف المحمول. يرجى استخدام روابط فيديو Youtube و Vimeo.",
  register_pin_text: "يرجى اختيار رمز PIN الشخصي المكون من 6 أرقام. سيكون هذا الرمز مطلوباً لتمكين وظائف إعادة تعيين الحساب.",
  internal_project: "داخلي",
  external_projects: "خارجي",
  in_deacticted: "القسم الداخلي معطل.",
  create_article: "إنشاء مقال",
  new_article_selection: "إنشاء مقال لخلاصة الأخبار الخارجية",
  new_article_selection_internal: "إنشاء مقال داخلي",
  active_trans_title: "تفعيل الترجمة التلقائية؟",
  active_trans: "عند التفعيل، سيتم ترجمة جميع رسائل الدردشة الواردة إلى لغة التطبيق المحددة.",
  disable_trans: "هل تريد حقاً إلغاء تفعيل الترجمة التلقائية؟",
  allow_access_chat: "عرض سجل الدردشة الكامل",
  toggle_chat_history_on: "هل تريد حقاً أن يرى المستخدم سجل الدردشة الكامل؟",
  toggle_chat_history_off: "هل تريد حقاً أن يرى المستخدم سجل الدردشة فقط من نقطة الانضمام إلى الدردشة؟",
  check_selected_settings: "يرجى التحقق من إعدادات سجل الدردشة لجميع المستخدمين المحددين!",
  chat_from_start_have: "لقد انضممت إلى هذه المجموعة. تم مشاركة سجل الدردشة.",
  chat_from_start_has: "انضم إلى هذه المجموعة. تم مشاركة سجل الدردشة.",
  Address: "العنوان",
  read_by: "قرأه",
  deliver_to: "تم التسليم إلى",
  remaining: "متبقي",
  message_info: "معلومات الرسالة",
  request_to_join_only: "طلب الانضمام",
  unfollow: "إلغاء المتابعة",
  company_username: "اسم المستخدم",
  month: ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"],
  remove_my_admin_right: "إزالة صلاحياتي كمدير",
  makeEmp: "هل تريد حقاً إزالة صلاحيات مدير الشركة من المستخدم؟",
  remove_my_self: "هل تريد حقاً إزالة صلاحيات مدير الشركة من حسابك؟",
  makeAdmin: "هل تريد حقاً منح المستخدم صلاحيات مدير الشركة؟",
  remove_member: "إزالة عضو",
  remove_following_confirm: "هل تريد حقاً إزالة {name} من قائمة المتابَعين؟",
  remove_follower_confirm: "هل تريد حقاً إزالة {name} من متابعيك؟ إذا أزلته/ها فلن يتم إبلاغه/ها.",
  do_you_really_want_to_remove: "هل تريد حقاً إزالة اسم المستخدم من الشركة؟",
  invite_all: "دعوة جميع أعضاء الشركة",
  invite_all_members: "دعوة جميع الأعضاء",
  mems: "جميع الأعضاء الآخرين",
  dep_loc: "القسم/الموقع/الفريق",
  depAdmin: "مدير القسم",
  add_remove_admin: "إضافة/إزالة منصب مدير الشركة",
  add_remove_dep_admin: "إضافة/إزالة منصب مدير القسم",
  remove_employees_dept: "إزالة الموظفين من",
  want_to_join_dep: "اسم المستخدم يريد الانضمام إلى القسم/الموقع/الفريق depname من شركة companyname.",
  you_invited: "تمت دعوتك للانضمام إلى القسم/الموقع/الفريق depname من شركة companyname.",
  dep_remove: "هل تريد حقاً إزالة صلاحيات المدير للقسم أو الموقع من المستخدم؟",
  add_dep: "هل تريد حقاً منح المستخدم صلاحيات المدير للقسم أو الموقع؟",
  my_self_dep_remove: "هل تريد حقاً إزالة صلاحيات مدير القسم من حسابك؟",
  member: "عضو",
  admin: "مدير",
  remove_project_admin: "هل تريد حقاً إزالة العضو من المشروع؟",
  remove_my_self_project: "هل تريد حقاً إزالة صلاحيات المدير؟",
  remove_member_admin_right: "هل تريد حقاً إزالة صلاحيات المدير من المستخدم؟",
  add_member_admin_right: "هل تريد حقاً إضافة صلاحيات المدير إلى المستخدم؟",
  add_remove_Poss: "إضافة/إزالة منصب المدير",
  forward: "إعادة توجيه",
  edit: "تعديل",
  only_kjuup_plus_can: "فقط شركات Kjuup+ يمكنها نشر المقالات.",
  add_images: "إضافة صورة/صور",
  request_confirmation: 'دعوات المشاريع المعلقة',
  Activity: "النشاط",
  latest_messages: "أحدث الرسائل",
  hours: "ساعات",
  minute: "دقائق",
  seconds: "ثواني",
  days: "أيام",
  yesterday: "أمس",
  last_week: "الأسبوع الماضي",
  next_week: "الأسبوع القادم",
  Last_month: "الشهر الماضي",
  All: "الكل",
  register_plus: "التسجيل بلس",
  select_files: "اختر الملفات",
  monthsFullName: ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"],
  company_deploc_receivers_message: "رابط دعوة إلى قسم شركة company name في Kjuup. يرجى النقر على الرابط للتسجيل في Kjuup والانضمام إلى شركة company name.",
  no_news: "لا توجد أخبار متاحة",
  reminder: "تذكير",
  np_reminder: "لا توجد مهام",
  move_to_reminder: "نقل إلى ToDo",
  remove_reminder: "هل تريد حقاً إزالة هذه الرسالة من قائمة مهامك؟",
  remove_all_reminder: "إزالة جميع المهام",
  remove_all_confirm: "هل تريد حقاً إزالة جميع الرسائل من قائمة مهامك؟",
  remove_from_reminder: "إزالة من التذكير",
  prevent_email: "لا يمكن استخدام البريد الإلكتروني كاسم مستخدم.",
  allow_noti: "يرجى السماح بالإشعارات.",
  join_cap: "انضمام",
  pass_minimum: "**كلمة المرور تتطلب 12 حرفاً بما في ذلك حرف صغير، حرف كبير، رقم ورمز خاص.",
  pass_error: "يرجى التحقق من متطلبات كلمة المرور",
  people_that_like_article: "الأشخاص الذين أعجبوا بالمقال.",
  people_who_like_article: "الأشخاص الذين أعجبوا بمقالك.",
  message_delete: "تم حذف هذه الرسالة.",
  message_edited: "تم التعديل",
  edit_message: "تعديل الرسالة",
  edit_window_expired: "يمكن تعديل الرسائل خلال 10 دقائق فقط بعد الإرسال.",
  message_edit_save: "حفظ",
  copy: "نسخ",
  bookmark: "إشارة مرجعية",
  add_reaction: "إضافة تفاعل",
  delete_message: "حذف الرسالة",
  more_options: "المزيد من الخيارات",
  info: "معلومات",
  link_invite: "دعوة عبر الرابط",
  ll_nkk: "دعوة إلى Kjuup",
  selected: "محدد",
  is_active: "نشط",
  inactive: "غير نشط",
  last_online: "آخر ظهور {{when}}",
  remove_user_l: "إزالة",
  link_expire: "كل رابط تم إنشاؤه سيكون صالحاً لمدة 72 ساعة.",
  company_language: "لغة الشركة",
  company_language_info: "سيتم استخدام اختيار اللغة لجميع تأكيدات البريد الإلكتروني المتعلقة بالشركة.",
  s_image: "صورة",
  m_image: "صور",
  removeMsg: "اضغط للإزالة",
  block: 'حظر',
  unblock: 'إلغاء الحظر',
  blocks: 'هل أنت متأكد أنك تريد حظر هذا المستخدم؟',
  unblocks: 'هل أنت متأكد أنك تريد إلغاء حظر هذا المستخدم؟',
  bolcked_click_un_block: 'لقد حظرت هذا الاتصال. انقر هنا لإزالة الحظر.',
  you_have_unblocked: 'لقد ألغيت حظر هذا الاتصال.',
  you_have_blocked: 'لقد حظرت هذا الاتصال.',
  unblock_to_send: 'ألغِ حظر المستخدم لإرسال رسالة.',
  pilot_text: "ذكاء اصطناعي متخصص في مواضيع البناء",
  startup_screen_label: "شاشة البدء",
  startup_screen_info: "اختر الشاشة التي تفتح عند بدء Kjuup.",
  startup_screen_feed: "Home",
  startup_screen_messages: "الرسائل",
  startup_screen_saved: "تم تحديث شاشة البدء",
email_on: "إشعارات البريد الإلكتروني للدردشات",
  email_on_grp: "إشعار البريد الإلكتروني",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "تفعيل أو إلغاء تفعيل إشعارات البريد الإلكتروني لهذا المشروع. هذا الخيار متاح فقط عندما يتم تفعيل \"إشعارات البريد الإلكتروني للدردشات\" عبر الإعدادات الشخصية.",
  todo_notification_info: "سيتم إشعارك في كل مرة يتم فيها تعيين مهمة جديدة لك.",
  info_val: "ستتلقى بريدًا إلكترونيًا إذا لم تتم قراءة رسالة دردشة جديدة خلال وقت قصير. يمكنك إيقاف ذلك لمشاريع أو دردشات محددة في إعداداتها أو في معلومات مجموعة الدردشة.",
  email_groups: "تفعيل أو إلغاء تفعيل إشعارات البريد الإلكتروني لهذه الدردشة. هذا الخيار متاح فقط عندما يتم تفعيل \"إشعارات البريد الإلكتروني للدردشات\" عبر الإعدادات الشخصية وإعدادات المشروع.",
  add_update_email: "إضافة/تحديث البريد الإلكتروني",
  text_to_verifiy: "يمكن تفعيل خيار \"إشعارات البريد الإلكتروني للدردشات\" فقط إذا كان لديك عنوان بريد إلكتروني موثق في الملف.",
  stored_email: "البريد الإلكتروني المخزن: ",
  verify_email: "التأكيد معلق!",
  join_call: "انضمام",
  call_is_started: "بدأت المكالمة",
  start_chat: "بدء دردشة مباشرة؟",
  project_rooms: "المشاريع",
  download_selected: "تحميل",
  add_employee_confirm: 'هل أنت متأكد أنك تريد إضافة هذا المستخدم إلى الشركة؟',
  invalid_deeplink: "رابط deeplink غير صالح. معاملات مطلوبة مفقودة.",
  deeplink_error: "تعذر معالجة deeplink. يرجى المحاولة مرة أخرى لاحقاً.",
  reply: "رد",
  reply_enter: "أدخل الرد...",
  reply_sent_successfully: "تم إرسال الرد بنجاح",
  reply_failed: "فشل إرسال الرد",
  reply_failed_generic: "فشل إرسال الرد. يرجى المحاولة مرة أخرى.",
  replying_to_message: "الرد على الرسالة",
  cancel_reply: "إلغاء الرد",
  voice_message: "رسالة صوتية",
  send: "إرسال",
  cancel: "إلغاء",
  type_your_reply: "اكتب ردك...",
  suggested_replies: "الردود المقترحة",
  suggestions_error: "فشل تحميل الاقتراحات",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Image — Click to load",
  lazy_media_audio: "Voice message — Click to load",
  lazy_media_doc: "Document — Click to load",
  lazy_media_video: "Video — Click to load",
  suggestion_loading_message: "لحظة واحدة. يتم إعداد نصك بشكل فردي لك.",
  loading_chat_message: "جاري تحميل الدردشة...",
  extracting_message: "جارٍ استخراج الرسالة...",
  create_todo: "إنشاء ToDo",
  create_todo_confirmation: "هل تريد إنشاء ToDo من هذه الرسالة؟",
  select_project_required: "يرجى اختيار مشروع/مجموعة",
  only_assigned_can_change_status: "فقط المستخدمون المعينون يمكنهم تغيير الحالة",
  todo_summary: "الملخص",
  todo_summary_placeholder: "أدخل ملخص المهمة...",
  todo_date: "التاريخ",
  todo_time: "الوقت",
  todo_date_hint: "اتركه فارغاً لاستخدام تاريخ/وقت الرسالة الأصلية",
  todo_created_success: "تم إنشاء ToDo بنجاح",
  todo_creation_failed: "فشل إنشاء ToDo",
  create: "إنشاء",
  image: "صورة",
  images: "صور",
  remove_all_images: "إزالة جميع الصور",
  remove_image: "إزالة الصورة",
  remove_document: "إزالة المستند",
  remove_recording: "إزالة التسجيل",
  play_recording: "تشغيل التسجيل",
  upload_image: "رفع صورة",
  upload_document: "رفع مستند",
  record_audio: "تسجيل صوتي",
  stop_recording: "إيقاف التسجيل",
  stop_recording_text: "إيقاف التسجيل",
  please_remove_current_attachment: "يرجى إزالة المرفق الحالي إلى",
  please_upload_image_file: "يرجى رفع ملف صورة صالح",
  please_upload_valid_document: "يرجى رفع ملف مستند صالح",
  searching_messages: "جاري البحث عن الرسائل...",
  loading_more: "جاري تحميل المزيد...",
  loading_more_users: "جاري تحميل المزيد من المستخدمين...",
  load_more_users: "تحميل المزيد من المستخدمين",
  no_more_users_to_load: "لا يوجد المزيد من المستخدمين للتحميل",
  no_messages_found: "لم يتم العثور على رسائل",
  try_different_keyword: "جرب كلمة مفتاحية مختلفة أو تحقق من الإملاء.",
  search_messages: "البحث عن الرسائل ومجموعات الدردشة والمشاريع والمستخدمين...",
  todo: "ToDo",
  np_todo: "لا توجد مهام",
  move_to_todo: "حفظ كـ ToDo",
  remove_todo: "هل تريد حقاً إزالة ToDo؟",
  remove_all_todo: "إزالة جميع المهام",
  remove_all_todo_confirm: "هل تريد حقاً إزالة جميع المهام؟",
  add_to_todo: "إضافة إلى ToDo",
  remove_from_todo: "إزالة من ToDo",
  confirm: "تأكيد",
  ok: "موافق",
  read_more: "اقرأ المزيد",
  show_less: "عرض أقل",
  show_more: "عرض المزيد",
  audio: "صوتي",
  video: "فيديو",
  notification_schedule: "جدول الإشعارات",
  notification_schedule_desc: "ستتلقى إشعارات الدفع والبريد الإلكتروني فقط في الساعات التي تختارها. خارج هذه الأوقات، سيتم إيقافها.",
  learn_more: "معرفة المزيد",
  allow_notifications: "السماح بالإشعارات:",
  every_day: "كل يوم",
  weekdays: "أيام الأسبوع (من الاثنين إلى الجمعة)",
  custom: "مخصص",
  monday: "الاثنين",
  tuesday: "الثلاثاء",
  wednesday: "الأربعاء",
  thursday: "الخميس",
  friday: "الجمعة",
  saturday: "السبت",
  sunday: "الأحد",
  to: "إلى",
  notification_settings: "الإشعارات",
  notification_settings_saved: "تم حفظ إعدادات الإشعارات بنجاح",
  notification_settings_error: "فشل حفظ إعدادات الإشعارات",
  unavailability_note: "ملاحظة عدم التوفر",
  unavailability_description: "قم بتعيين ملاحظة خارج المكتب. أثناء التفعيل، تُعرض الملاحظة للآخرين في جميع محادثاتك ويتم إيقاف الإشعارات مؤقتًا.",
  unavailability_start_date: "تاريخ البدء",
  unavailability_end_date: "تاريخ الانتهاء",
  unavailability_message: "الرسالة",
  unavailability_message_hint: "استخدم {endDate} كعنصر نائب لتاريخ عودتك.",
  unavailability_replacement: "جهة اتصال بديلة",
  unavailability_replacement_placeholder: "أدخل معرف المستخدم للطلبات العاجلة",
  unavailability_replacement_current: "البديل الحالي",
  unavailability_replacement_hint: "إذا تم تعيينه، سيتم عرض رابط للتواصل مع هذا الشخص للأمور العاجلة في ملاحظة عدم التوفر الخاصة بك.",
  unavailability_replacement_none: "بدون بديل (اختياري)",
  unavailability_contact_urgent: "للطلبات العاجلة تواصل مع",
  unavailability_default_message: "أنا حالياً خارج المكتب وليس لدي وصول إلى Kjuup. سأكون متاحاً مرة أخرى اعتباراً من {endDate} وسأتواصل معك حينها.",
  unavailability_save: "حفظ",
  unavailability_deactivate: "إلغاء التفعيل",
  unavailability_active_until: "نشط حتى",
  unavailability_saved: "تم حفظ ملاحظة عدم التوفر",
  unavailability_save_error: "فشل حفظ ملاحظة عدم التوفر",
  unavailability_deactivated: "تم إلغاء تفعيل ملاحظة عدم التوفر",
  unavailability_end_date_required: "تاريخ الانتهاء مطلوب",
  start_time_before_end_time: "يجب أن يكون وقت البدء قبل وقت الانتهاء",
  loading: "جاري التحميل",
  disabled: "معطل",
  enable: "تفعيل",
  disable: "إلغاء التفعيل",
  forwarded: "تم إعادة التوجيه",
  message_forwarded: "تم إعادة توجيه الرسالة!",
  schedule_article_post: "جدولة نشر المقال",
  date: "التاريخ",
  time: "الوقت",
  scheduled_for_publication: "مجدول للنشر",
  article_will_be_published_on: "سيتم نشر المقال في:",
  reset_selection: "إعادة تعيين التحديد",
  continue: "متابعة",
  cancel: "إلغاء",
  error_loading_members: "خطأ في تحميل الأعضاء",
  please_fill_all_fields: "يرجى ملء جميع الحقول",
  invalid_email: "عنوان بريد إلكتروني غير صالح",
  member_added_successfully: "تم إضافة العضو بنجاح",
  error_onboarding_user: "خطأ في إضافة المستخدم",
  error_creating_chat: "خطأ في إنشاء الدردشة",
  error_creating_group: "خطأ في إنشاء المجموعة",
  new_group: "مجموعة جديدة",
  please_select_or_enter_group_name: "يرجى اختيار مجموعة أو إدخال اسم مجموعة",
  please_select_or_enter_room_name: "يرجى اختيار مشروع أو إدخال اسم مشروع",
  error_creating_room: "خطأ في إنشاء المشروع",
  error_opening_chat: "خطأ في فتح الدردشة",
  privacy_modal_text: "اختر \"خاص\" فقط إذا كانت الدردشة لا تحتوي على محتوى مهني ذي صلة لمدير المشروع.",
  not_private: "ليس خاصاً",
  private: "خاص",
  error_loading_groups: "خطأ في تحميل المجموعات",
  automatic_chat_export: "تصدير الدردشة التلقائي",
  automatic_chat_export_info: "بعد التفعيل، سيتم إرسال سجل الدردشة تلقائياً إلى عنوان البريد الإلكتروني المحدد كل شهر.",
  automatic_chat_export_no_email: "لتفعيل تصدير الدردشة التلقائي، يجب عليك أولاً إضافة عنوان بريد إلكتروني. يمكنك إضافة عنوان بريدك الإلكتروني في الإعدادات الشخصية.",
  enter_email: "أدخل البريد الإلكتروني",
  update: "تحديث",
  confirm: "تأكيد",
  export_to_email: "سيذهب التصدير إلى البريد الإلكتروني التالي.",
  start_chat_button: "رسالة جديدة",
  matching_existing_chats: "مطابقة الدردشات الموجودة",
  subject: "الموضوع",
  add_subject: "إضافة موضوع",
  chat_subject: "موضوع الدردشة:",
  set_project_room: "تعيين المشروع",
  matching_existing_project_rooms: "مطابقة المشاريع الموجودة",
  name_project_room: "تسمية المشروع",
  professional_or_private: "مهني أو خاص",
  professional: "مهني",
  privacy_modal_text_updated: "اختر \"خاص\" فقط إذا كانت الدردشة لا تحتوي على محتوى مهني ذي صلة لمديري المشاريع. الدردشات الخاصة غير مرئية لمديري المشاريع.",
  create_internal_chat: "دردشة خارجية - أم داخلية؟",
  internal_chat_description: "يمكن إضافة موظفي شركتك فقط إلى الدردشات الداخلية.",
  yes: "نعم",
  no: "لا",
  chat_is_being_created: "جاري إنشاء الدردشة...",
  discard_article_confirm: "هل تريد حقاً تجاهل التغييرات على هذا المقال؟",
  please_enter_article_title: "يرجى إدخال عنوان المقال أولاً.",
  please_add_mandatory_fields: "يرجى إضافة جميع الحقول الإلزامية",
  product_label: "المنتج:",
  no_companies_found: "لم يتم العثور على شركات",
  visible_to_all_followers: "مرئي لجميع أعضاء Kjuup",
  only_visible_to_employees: "مرئي للموظفين فقط",
  something_went_wrong: "حدث خطأ ما، يرجى المحاولة مرة أخرى",
  please_select_department: "يرجى اختيار القسم/الموقع",
  schedule: "جدولة",
  please_select_future_date_time: "يرجى اختيار تاريخ ووقت مستقبليين لجدولة المقال.",
  please_select_different_date_time: "يرجى اختيار تاريخ أو وقت مختلف لجدولة المقال.",
  please_select_later_time: "يرجى اختيار وقت لاحق للوقت الحالي لليوم.",
  unpin_article: "إلغاء تثبيت المقال",
  pin_article: "تثبيت المقال",
  and: "و",
  others: "آخرون",
  at: "في",
  mute: "كتم",
  unmute: "إلغاء الكتم",
  chat_muted_successfully: "تم كتم الدردشة بنجاح",
  chat_unmuted_successfully: "تم إلغاء كتم الدردشة بنجاح",
  mute_chat_confirm: "هل تريد حقاً كتم هذه الدردشة؟ لن تتلقى إشعارات للرسائل الجديدة.",
  unmute_chat_confirm: "هل تريد حقاً إلغاء كتم هذه الدردشة؟ ستحصل مرة أخرى على إشعارات للرسائل الجديدة.",
  please_select_group_to_forward: "يرجى اختيار مجموعة لإعادة توجيه الرسالة",
  record_not_found: "لم يتم العثور على السجل!",
  please_select_position: "يرجى اختيار المنصب",
  delete_article_confirm: "هل أنت متأكد أنك تريد حذف هذا المقال؟",
  delete_company_service_confirm: "هل أنت متأكد أنك تريد حذف خدمة الشركة؟",
  block_translation_confirm: "هل تريد حقاً حظر الترجمة التلقائية في المشاريع لجميع أعضاء الشركة",
  unblock_translation_confirm: "هل تريد حقاً إلغاء حظر الترجمة التلقائية في المشاريع لجميع أعضاء الشركة",
  please_select_file: "يرجى اختيار ملف للرفع",
  role_in_building_industry: "الدور في صناعة البناء*",
  invalid_email_address: "عنوان بريد إلكتروني غير صالح",
  please_enter_password: "يرجى إدخال كلمة المرور",
  password_change_email_sent: "تم إرسال بريد إلكتروني إلى بريدك الإلكتروني في Kjuup. يرجى تأكيد كلمة المرور الجديدة بالنقر على رابط التأكيد في البريد الإلكتروني.",
  please_enter_username: "يرجى إدخال اسم المستخدم",
  username_same_as_before: "لا يمكن أن يكون اسم المستخدم كما كان من قبل",
  profile_deleted_successfully: "تم حذف الملف الشخصي بنجاح",
  hardware_requirements: "متطلبات الأجهزة",
  hardware_requirements_list: "• 4GB RAM<br/>• سرعة المعالج كحد أدنى 2GHz<br/>• Windows 7 أو أحدث / جميع إصدارات macOS",
  submitting: "جاري الإرسال...",
  signing_in: "جاري تسجيل الدخول...",
  please_enter_service_name: "يرجى إدخال اسم الخدمة",
  something_went_wrong_error: "آه! حدث خطأ ما...",
  something_went_wrong_try_again: "عذراً، حدث خطأ هناك. حاول مرة أخرى",
  position_label: "المنصب:",
  loading_room: "جاري تحميل المشروع...",
  navigating_to_room: "الانتقال إلى المشروع",
  loading_chat: "جاري تحميل الدردشة...",
  translate: "ترجمة",
  show_original: "عرض الأصل",
  saving: "جاري الحفظ...",
  language_selection_info: "يتم استخدام اختيار اللغة لجميع تأكيدات البريد الإلكتروني المتعلقة بالشركة.",
  nav_call: "مكالمة",
  nav_home: "الرئيسية",
  nav_messages: "الرسائل",
  nav_todo: "مهام",
  nav_rooms: "المشاريع",
  nav_all_rooms: "جميع المشاريع",
  pinned_rooms_max: "يمكنك تثبيت ما يصل إلى 10 مشاريع.",
  pinned_room_unpin: "إلغاء التثبيت",
  pinned_rooms_drop: "اسحب مشروعك إلى هنا للاختيار السريع",
  nav_profile: "الملف الشخصي",
  nav_company: "الشركة",
  nav_company_documents: "المستندات",
  nav_logout: "تسجيل الخروج",
  add_member_title: "إضافة عضو",
  continue_btn: "متابعة",
  search_placeholder: "بحث",
  no_members_found: "لم يتم العثور على أعضاء",
  no_groups_found: "لم يتم العثور على مجموعات",
  no_rooms_found: "لم يتم العثور على مشاريع",
  search_users_tab: "المستخدمون",
  search_documents_tab: "مستندات",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "لا توجد ملفات",
  no_documents_available: "No documents",
  searching_users: "جارٍ البحث عن المستخدمين...",
  no_users_found: "لم يتم العثور على مستخدمين",
  search_emails_tab: "البريد الإلكتروني",
  searching_emails: "جارٍ البحث عن رسائل البريد...",
  no_emails_found: "لم يتم العثور على رسائل بريد",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "مجموعة غير مسماة",
  unnamed_room: "مشروع غير مسمى",
  all_members: "الكل",
  room_label: "المشروع:",
  subject_label: "الموضوع:",
  no_members: "لا يوجد أعضاء",
  creating_structure: "جاري إنشاء هيكلك",
  opening_chat: "جاري فتح الدردشة",
  please_wait: "يرجى الانتظار...",
  loading_todo: "جاري تحميل ToDo...",
  task_updated: "تم تحديث المهمة",
  error_updating_task: "خطأ في تحديث المهمة",
  task_deleted: "تم حذف المهمة",
  error_deleting_task: "خطأ في حذف المهمة",
  delete_task_confirm: "هل أنت متأكد أنك تريد حذف هذه المهمة؟",
  description_label: "الوصف",
  description_placeholder: "أدخل الوصف...",
  date_time_label: "التاريخ والوقت",
  save_hint: "Ctrl+Enter للحفظ، Esc للإلغاء",
  edit_label: "تعديل",
  delete_label: "حذف",
  todo_list_title: "مهام",
  tasks_count: "مهام",
  search_placeholder_todo: "بحث...",
  select_task_to_open_chat: "اختر مهمة لفتح الدردشة",
  today: "اليوم",
  yesterday: "أمس",
  time_suffix: "",
  from_chat: "ToDo المصدر",
  assigned_to: "معين إلى",
  assign_users: "تعيين المستخدمين",
  no_users_assigned: "لا يوجد مستخدمون معينون",
  assign: "تعيين",
  assign_to: "تعيين إلى...",
  navigate_to_chat: "الانتقال إلى الدردشة",
  navigate_to_email: "الانتقال إلى البريد الإلكتروني",
  show_original_message: "عرض المصدر",
  hide_original_message: "إخفاء المصدر",
  status_pending: "معلق",
  status_in_progress: "قيد التنفيذ",
  status_completed: "مكتمل",
  show: "عرض",
  close: "إغلاق",
  status_confirmed: "[تم التأكيد]",
  log_todo_created: "ToDo [تم إنشاؤه]",
  log_todo_confirmed: "ToDo [تم تأكيده]",
  log_todo_deleted: "ToDo [تم حذفه]",
  log_todo_updated: "ToDo [تم تحديثه]",
  log_description_updated: "[تم تحديث الوصف]",
  log_deadline_updated: "[تم تحديث الموعد النهائي]",
  log_assigned_to: "[تم التعيين إلى] {name}",
  log_unassigned_from: "[تم إلغاء التعيين من] {name}",
  log_assignment_added: "[تمت إضافة التعيين]: {name}",
  log_assignment_removed: "[تم إزالة التعيين]: {name}",
  log_status_updated: "[تم تغيير الحالة من] {from} [إلى] {to}",
  log_status_changed: "[تم تغيير الحالة]",
  log_status_changed_to: "[تم تغيير الحالة إلى] {status}",
  log_changed_status_to: "[تم تغيير الحالة إلى]:",
  log_for_user: "[للمستخدم]:",
  log_user_updated_status: "[قام المستخدم بتحديث حالة مهمته]",
  log_changed_date_to: "[تم تغيير التاريخ إلى]:",
  log_changed_description_to: "[تم تغيير الوصف إلى]:",
  log_moved_to: "[تم النقل إلى] {status}",
  todo_status_updated_from: "[من]",
  todo_status_updated_to: "[إلى]",
  filter_pending: "معلق",
  filter_confirmed: "مؤكد",
  filter_assigned_to_me: "مهامي",
  filter_assigned_by_me: "مُفوَّض",
  todo_project_label: "المشروع:",
  assigned_users: "المستخدمون المعينون:",
  todo_chat_label: "الدردشة:",
  history: "السجل",
  todo_assigned_by: "مُعيَّن من قِبل:",
  todo_assigned_push: "ToDo مُعيَّن:",
  todo_assigned_push_empty: "تم تعيين ToDo جديد لك.",
  search_groups: "المجموعات",
  search_chat_groups: "مجموعات الدردشة",
  search_project_room: "المشروع",
  search_messages_tab: "الرسائل",
  searching_groups: "جارٍ البحث عن المجموعات...",
  searching_rooms: "جارٍ البحث عن المشاريع...",
  no_groups_found: "لم يتم العثور على مجموعات",
  no_rooms_found: "لم يتم العثور على مشاريع",
  create_poll: "استطلاع",
  poll_question_label: "السؤال",
  poll_question_placeholder: "اطرح سؤالاً",
  poll_options_label: "الخيارات",
  poll_option: "خيار",
  poll_add_option: "إضافة خيار",
  poll_allow_multiple: "السماح بإجابات متعددة",
  poll_multiple_allowed: "اختر خياراً واحداً أو أكثر",
  poll_select_option: "اختر خياراً واحداً",
  poll_view_votes: "عرض الأصوات",
  poll_vote_singular: "صوت",
  poll_vote_plural: "أصوات",
  poll_votes: "نتائج الاستطلاع",
  poll_no_votes_yet: "لا توجد أصوات بعد",
  transcript_step_processing: "النسخ قيد التنفيذ...",
  ai_transcript_tab: "AI-نسخ",
  ai_transcript_info: "متاح فقط للرسائل الصوتية التي تم إنشاؤها بعد 09.03.2026.",
  transcript_more: "...المزيد",
  transcript_less: "...أقل",
  ki_transcript_voice_message: "KI-نسخة نصية للرسالة الصوتية",
  ki_image_analysis: "تحليل الصور بالذكاء الاصطناعي",
  type_message: "اكتب رسالة",
  email_tab_messages: "الرسائل",
  email_tab_email: "البريد الإلكتروني",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "حسابات البريد الإلكتروني",
  email_connect_gmail: "ربط Gmail",
  email_connect_outlook: "ربط Outlook",
  email_no_accounts: "لا توجد حسابات بريد إلكتروني متصلة",
  email_no_accounts_hint: "اربط حساب بريد إلكتروني في إعدادات ملفك الشخصي",
  email_no_messages: "لا توجد رسائل بريد إلكتروني",
  email_from: "من",
  email_to: "إلى",
  email_subject: "الموضوع",
  email_disconnect: "قطع الاتصال",
  email_disconnect_confirm: "هل أنت متأكد من أنك تريد فصل حساب البريد الإلكتروني هذا؟ ستتم إزالة جميع رسائل البريد الإلكتروني المتزامنة.",
  email_account_disconnected: "تم فصل حساب البريد الإلكتروني بنجاح",
  email_account_disconnect_failed: "فشل في فصل الحساب",
  email_connecting: "جاري الاتصال...",
  email_account_connected: "تم ربط الحساب بنجاح",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "انتقل إلى الإعدادات",
  email_date: "التاريخ",
  email_reply: "رد",
  email_forward: "إعادة توجيه",
  email_copy_text: "نسخ النص",
  email_text_copied: "تم النسخ!",
  email_text_copy_failed: "تعذر نسخ النص.",
  email_delete: "حذف",
  email_not_spam: "ليس بريدًا عشوائيًا",
  email_not_spam_success: "تم نقل البريد إلى صندوق الوارد.",
  email_not_spam_failed: "فشل في النقل إلى صندوق الوارد.",
  email_delete_confirm: "هل أنت متأكد أنك تريد حذف هذا البريد الإلكتروني؟",
  email_delete_from_folder: "هل أنت متأكد أنك تريد الحذف من {folder}؟",
  email_delete_permanent_from_folder:
    "هل أنت متأكد أنك تريد الحذف نهائيًا من {folder}؟ لا يمكن التراجع عن هذا الإجراء.",
  email_save_draft_confirm: "هل تريد حفظ هذا البريد كمسودة؟",
  email_save_draft: "حفظ كمسودة",
  email_discard: "تجاهل",
  email_back_to_compose: "العودة إلى التحرير",
  email_draft_saved: "تم حفظ المسودة.",
  email_draft_save_failed: "فشل في حفظ المسودة.",
  email_loading: "جاري تحميل الرسائل...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "تحديد",
  email_attachment_singular: "مرفق",
  email_attachment_plural: "مرفقات",
  email_back: "رجوع",
  email_download: "تحميل",
  email_close: "إغلاق",
  email_preview: "معاينة",
  email_preview_not_available: "المعاينة غير متوفرة",
  email_preview_failed: "المعاينة غير متوفرة",
  select_attachments: "تحديد المرفقات",
  email_loading_preview: "جاري تحميل المعاينة...",
  email_mark_unread_failed: "بريد إلكتروني لا يمكن تعليمه كغير مقروء.",
  email_delete_failed: "بريد إلكتروني لا يمكن حذفه.",
  filter_all: "الكل",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "الرسائل المباشرة",
  my_notes: "My Space",
  filter_internal_groups: "محادثات جماعية داخلية",
  filter_external_groups: "محادثات جماعية خارجية",
  filter_group_chats: "محادثات جماعية",
  filter_groups_internal: "داخلية",
  filter_groups_external: "خارجية",
  filter_unread_only: "غير المقروءة فقط",
  room_daily_briefing_info: "عند التفعيل، يتم إنشاء تقرير لهذا المشروع كل 24 ساعة في الوقت المحدد في الإعدادات الشخصية — ولكن فقط إذا كان هناك نشاط خلال تلك الفترة.",
  email_select_all: "تحديد الكل",
  email_deselect_all: "إلغاء تحديد الكل",
  email_reply_all: "الرد على الكل",
  email_reply_placeholder: "اكتب ردك...",
  email_forward_placeholder: "أضف رسالة...",
  email_edit_draft: "تعديل المسودة",
  email_attach: "إرفاق",
  email_attachment_from_original: "من الرسالة الأصلية",
  email_remove: "إزالة",
  email_drop_files: "أسقط الملفات للإرفاق",
  email_loading_attachments: "جاري تحميل المرفقات...",
  email_archive: "أرشفة",
  mark_unread: "تحديد كغير مقروء",
  mark_read: "تحديد كمقروء",
  email_all_accounts: "جميع الحسابات",
  email_error: "خطأ",
  email_delete_email_failed: "فشل حذف البريد الإلكتروني.",
  enter_url: "أدخل عنوان URL",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'اشترك الآن',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: 'شهر واحد تجربة مجانية',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'لا يوجد دفع اليوم. لا تُطلب بيانات بطاقة الائتمان قبل بدء الاشتراك المدفوع.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'إدارة جميع حسابات البريد الإلكتروني مباشرة في Kjuup',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'الذكاء الاصطناعي يكتب الردود – أنت تؤكد فقط',
  kjuup_io_feature_tasks: 'المهام والتقويم محدثان تلقائيًا دائمًا',
  kjuup_io_choose_plan: 'اختر خطتك',
  kjuup_io_plan_monthly: 'شهري',
  kjuup_io_plan_yearly: 'سنوي',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'مؤمَّن بواسطة Stripe · إلغاء في أي وقت',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'تم استلام الدفع. جارٍ تفعيل اشتراكك…',
  kjuup_io_toast_activating_soon: 'تم استلام الدفع. سيتم تفعيل اشتراكك قريبًا.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: 'الوقت المتبقي: {count} ساعة',
  kjuup_io_trial_left_hour: 'الوقت المتبقي: ساعة واحدة',
  kjuup_io_trial_left_minutes: 'الوقت المتبقي: {count} دقيقة',
  kjuup_io_trial_left_minute: 'الوقت المتبقي: دقيقة واحدة',
  kjuup_io_trial_left_seconds: 'الوقت المتبقي: {count} ثانية',
  kjuup_io_trial_left_second: 'الوقت المتبقي: ثانية واحدة',
  kjuup_io_trial_ending_now: 'تنتهي فترتك التجريبية الآن…',
  kjuup_io_request_timeout: 'انتهت مدة الاتصال. يرجى المحاولة مرة أخرى.',
  kjuup_io_info_days_free: '{days} يومًا مجانًا بالكامل – يبدأ اشتراكك فقط بعد الفترة التجريبية.',
  kjuup_io_discount_total: 'خصمك: {percent}%',
  kjuup_io_discount_company: '{company}: {percent}%',
  kjuup_io_discount_personal: 'شخصي: {percent}%',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'إغلاق',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'انتهت فترتك التجريبية المجانية',
  kjuup_io_trial_ended_body: 'اشترك في Kjuup.io لمواصلة استخدام البريد الإلكتروني والميزات المميزة الأخرى.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'بدأت فترتك التجريبية المجانية',
  kjuup_io_toast_trial_fail: 'تعذّر بدء الفترة التجريبية المجانية',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / شهر',
  kjuup_io_save_amount_year: 'وفّر {price} سنويًا',
  kjuup_io_billed_annually_amount: '{price} تُفوتر سنويًا',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'ما ستحصل عليه:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'لا حاجة لبطاقة ائتمان – ابدأ فورًا دون إدخال بيانات الدفع.',
  kjuup_io_info_cancel_anytime: 'إلغاء في أي وقت – بلا التزام وبلا مخاطر.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'فترة الفوترة',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'تم حفظ طريقة الدفع. ستتم المحاسبة عند انتهاء الفترة التجريبية.',
  calendar_sync_info: 'قم بمزامنة جميع مهام Kjuup ToDo تلقائيًا مع تقويمك.',
  calendar_no_accounts: 'لا يوجد تقويم متصل بعد.',
  article_new_badge: 'جديد',
  article_new_posts: '{0} منشورات جديدة',
  documents: 'المستندات',
  add_documents: 'إضافة مستندات',
  no_preview_available: 'لا تتوفر معاينة',
  no_preview_hint: 'لا يمكن معاينة هذا النوع من الملفات، لكنه سيُرسل على أي حال.',
  max_documents_reached: 'يمكنك إرفاق ما يصل إلى 10 مستندات في المرة الواحدة.',
  open_file: 'فتح الملف',
  twofa_title: 'المصادقة الثنائية',
  twofa_method_totp: 'تطبيق المصادقة',
  twofa_method_sms: 'رسالة نصية',
  twofa_method_email: 'البريد الإلكتروني',
  twofa_enter_app: 'أدخل الرمز المكوّن من 6 أرقام من تطبيق المصادقة.',
  twofa_enter_sms: 'أدخل الرمز المكوّن من 6 أرقام الذي أرسلناه عبر رسالة نصية.',
  twofa_enter_email: 'أدخل الرمز المكوّن من 6 أرقام الذي أرسلناه إلى بريدك.',
  twofa_resend: 'إعادة إرسال الرمز',
  twofa_try_another: 'جرّب طريقة أخرى',
  twofa_remember_device: 'لا تسأل مرة أخرى على هذا الجهاز لمدة 30 يوماً',
  twofa_sent: 'أرسلنا رمزاً.',
  twofa_invalid_code: 'هذا الرمز غير صحيح. حاول مرة أخرى.',
  twofa_something_wrong: 'حدث خطأ. حاول مرة أخرى.',
  twofa_method_unavailable: 'طريقة التحقق هذه غير متاحة.',
  twofa_on_desc: 'المصادقة الثنائية مفعّلة. ستحتاج إلى رمز في كل مرة تسجّل فيها الدخول.',
  twofa_off_desc: 'أضف خطوة ثانية بعد كلمة المرور. تطبيقات المصادقة هي الخيار الأكثر أماناً.',
  twofa_methods: 'الطرق',
  twofa_on: 'مفعّل',
  twofa_add: 'إضافة',
  twofa_default_method: 'الطريقة الافتراضية',
  twofa_default: 'افتراضي',
  twofa_turn_off: 'إيقاف',
  twofa_disable_hint: 'أدخل كلمة المرور ورمزاً حالياً لإيقاف المصادقة الثنائية.',
  twofa_disable_need: 'أدخل كلمة المرور ورمز التحقق.',
  twofa_code_placeholder: 'رمز من 6 أرقام أو رمز احتياطي',
  twofa_send_code: 'إرسال رمز',
  twofa_primary_updated: 'تم تحديث طريقة التحقق الافتراضية.',
  twofa_disabled: 'تم إيقاف المصادقة الثنائية.',
  twofa_enabled: 'تم تفعيل المصادقة الثنائية.',
  twofa_totp_help: 'امسح رمز QR هذا بتطبيق Google Authenticator أو Authy أو 1Password. يمكنك أيضاً إدخال المفتاح يدوياً.',
  twofa_secret_copied: 'تم نسخ المفتاح',
  twofa_sms_help: 'أدخل رقمك بالصيغة الدولية. سنرسل رمزاً من 6 أرقام عبر رسالة نصية.',
  twofa_email_help: 'سنرسل رمزاً من 6 أرقام إلى البريد الإلكتروني لحسابك.',
  twofa_backup_title: 'الرموز الاحتياطية',
  twofa_backup_help: 'احفظ هذه الرموز لمرة واحدة في مكان آمن. يُستخدم كل رمز مرة واحدة إذا فقدت هاتفك.',
  twofa_copy_codes: 'نسخ الرموز',
  twofa_codes_copied: 'تم نسخ الرموز الاحتياطية',
  twofa_regenerate: 'الحصول على رموز احتياطية جديدة',
  twofa_regenerate_hint: 'يستبدل هذا الرموز الاحتياطية غير المستخدمة. أدخل كلمة المرور ورمزًا حاليًا.',
  twofa_backup_remaining: 'تبقّى {n} من الرموز الاحتياطية غير المستخدمة',
  twofa_new_codes: 'رموز احتياطية جديدة',
  twofa_sms_unavailable: 'رموز الرسائل النصية غير متاحة بعد.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "تُنسخ مهام كيوب المعيّنة لك إلى مشروع باسم Kjuup في Todoist. التغييرات في Todoist لا تُنسخ إلى الخلف.",
  todoist_connect: "ربط Todoist",
  todoist_connected: "تم ربط Todoist",
  todoist_connect_failed: "فشل ربط Todoist",
  todoist_disconnect: "قطع الاتصال",
  todoist_disconnected: "تم قطع اتصال Todoist",
  todoist_disconnect_confirm: "قطع اتصال Todoist؟ المهام الموجودة في Todoist تبقى. تتوقف المزامنة.",
  todoist_sync_now: "مزامنة الآن",
  todoist_syncing: "جارٍ المزامنة…",
  todoist_sync_done: "اكتملت المزامنة",
  todoist_sync_failed: "فشلت المزامنة",
  todoist_auth_error: "أعد ربط Todoist لمتابعة المزامنة.",
  todoist_last_sync: "آخر مزامنة",
  todoist_not_connected: "Todoist غير مرتبط",
  todoist_auth_url_failed: "تعذر فتح صفحة تفويض Todoist.",
  recommend_text: "انضم إلى Kjuup لتبقى على تواصل وتحافظ على تنظيم تواصلك. اجمع قنواتك في مكان واحد، واحتفظ بالرسائل في المشاريع الصحيحة، وابدأ كل صباح بملخص ومهامك – كل ذلك متزامن مع التطبيقات التي تستخدمها بالفعل. ابدأ مجانًا:",
  pro_auth_signin_title: 'مرحبًا بعودتك',
  pro_auth_signin_sub: 'سجّل الدخول باستخدام بريد العمل الإلكتروني.',
  pro_auth_email_or_username: 'البريد الإلكتروني أو اسم المستخدم',
  pro_auth_email_placeholder: 'name@company.de',
  pro_auth_forgot_password: 'هل نسيت كلمة المرور؟',
  pro_auth_create_account: 'إنشاء حساب',
  pro_auth_show_password: 'إظهار كلمة المرور',
  pro_auth_hide_password: 'إخفاء كلمة المرور',
  pro_auth_register_sub: 'سنرسل لك رابطًا لتأكيد بريدك الإلكتروني.',
  pro_auth_register_plus_sub: 'اختر اسم مستخدم وكلمة مرور. بعد ذلك تحدد رمز PIN الأمني.',
  pro_auth_check_credentials: 'تحقق من بريدك الإلكتروني وكلمة المرور',
  pro_news_export_pdf: 'تصدير كملف PDF',
  pro_news_pdf_failed: 'تعذر إنشاء ملف PDF.',
  pro_news_pdf_attachments: 'المرفقات',
  pro_news_pdf_video: 'فيديو',
  pro_auth_forgot_sub: 'أدخل بريدك الإلكتروني وسنرسل لك رابطًا لإعادة تعيين كلمة المرور.',
  pro_auth_send_link: 'إرسال رابط إعادة التعيين',
  pro_auth_plus_reset: 'إعادة التعيين باستخدام PIN',
  pro_auth_show_pin: 'إظهار PIN',
  pro_auth_hide_pin: 'إخفاء PIN',
  v2_auth_plus_only: 'Kjuup+ فقط',
  room_action_media: "الملفات",
  room_tab_overview: "نظرة عامة",
  room_tab_history: "السجل",
  chat_info_media: "الملفات",
  messages: "الرسائل",
  pro_todo_project_required: "يرجى اختيار مشروع",
  pro_todo_choose_project: "لأي مشروع هذه المهمة؟",
  cockpit_report_delete_confirm: "حذف هذا التقرير اليومي؟",
  cockpit_report_deleted: "تم حذف التقرير اليومي",
  cockpit_tab_company: "الشركة",
  cockpit_bookmarked_priorities: "المهام المحفوظة",
  cockpit_load_error: "تعذّر تحميل لوحة القيادة.",
  cockpit_retry: "حاول مرة أخرى",
  cockpit_yesterday: "أمس",
  cockpit_greeting_morning: "صباح الخير",
  cockpit_greeting_day: "مساء الخير",
  cockpit_greeting_evening: "مساء الخير",
  cockpit_assistant_q_open: "ما المفتوح اليوم؟",
  cockpit_assistant_q_summarize: "لخّص الدردشة {{room}}",
  cockpit_assistant_q_overdue: "ما المهام المتأخرة؟",
  cockpit_assistant_new: "{{n}} جديد",
  cockpit_assistant_important: "{{n}} مهم",
  cockpit_assistant_title: "مساعد Kjuup",
  cockpit_assistant_hint: "المس واسأل",
  room_overview_priority_no_detail: "لا يقدّم التقرير تفاصيل إضافية حول هذه الأولوية.",
  room_overview_priority_from: "المصدر: {{name}}",
  room_overview_priority_open_task: "فتح المهمة",
  cockpit_priority_position: "{{index}} من {{total}} أولويات",
  room_overview_today_title: "مهم اليوم",
  room_overview_all_tasks: "الكل",
  room_overview_tasks_empty: "لا توجد مواعيد نهائية أو مهام مفتوحة",
  room_overview_appointments_empty: "لا توجد مواعيد قادمة",
  room_overview_no_priorities: "لا توجد أولويات مفتوحة في أحدث تقرير.",
  cockpit_report_top5: "أهم 5 أولويات",
  cockpit_report_todo_created: "تم إنشاء المهمة",
  cockpit_report_source_missing: "تعذّر العثور على الرسالة المصدر.",
  delete_bookmarked_priority_confirm: "هل أنت متأكد أنك تريد حذف هذه المهمة المحفوظة؟",
  cockpit_report_create_todo: "إنشاء مهمة",
  cockpit_priorities_deleting: "جارٍ الحذف …",
  cockpit_priorities_select: "حذف عدة عناصر",
  cockpit_report_none: "لا توجد إدخالات.",
  cockpit_priorities_delete_confirm: "هل أنت متأكد أنك تريد حذف {count} من المهام المحفوظة؟",
  cockpit_priorities_delete_failed: "تعذّر حذف {count} من المهام",
  cockpit_priorities_deleted: "تم حذف {count} من المهام",
  cockpit_priorities_selected: "تم تحديد {count}",
  cockpit_channel_connected: "متصل",
  cockpit_channel_not_connected: "غير متصل",
  cockpit_channel_connect: "اتصال",
  cockpit_channel_chat: "دردشة Kjuup",
  cockpit_channel_active: "نشط",
  cockpit_channel_hidden: "مخفي",
  cockpit_channel_enable: "تفعيل",
  cockpit_channel_email: "البريد الإلكتروني",
  cockpit_channel_check: "التحقق من الاتصال",
  cockpit_channel_fix: "تحقق",
  cockpit_channel_forward: "عنوان إعادة التوجيه",
  cockpit_channel_not_set_up: "غير مُعدّ",
  cockpit_channel_set_up: "إعداد",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "انقطع الاتصال",
  cockpit_channel_importing: "جارٍ الاستيراد",
  cockpit_channel_removing: "جارٍ قطع الاتصال",
  cockpit_channel_reconnect: "إعادة الاتصال",
  cockpit_channels_title: "القنوات",
  cockpit_company_role_super_admin: "مدير الشركة",
  cockpit_company_role_dept_admin: "مدير القسم",
  cockpit_company_role_member: "موظف",
  cockpit_company_none: "لم يتم العثور على شركة Kjuup+",
  cockpit_company_eyebrow: "الشركة",
  cockpit_company_inactive: "غير نشطة",
  cockpit_company_settings: "إعدادات الشركة",
  cockpit_company_employees: "الموظفون",
  cockpit_company_internal_rooms: "المشاريع الداخلية",
  cockpit_report_all_projects: "جميع المشاريع",
  cockpit_report_progress_emails: "جارٍ تحليل رسائل البريد الإلكتروني",
  cockpit_report_progress_chats: "جارٍ تحليل رسائل الدردشة",
  cockpit_report_progress_documents: "جارٍ تحليل المرفقات والمستندات",
  cockpit_report_progress_tasks: "جارٍ تحليل المهام",
  cockpit_report_progress_summarizing: "جارٍ تحليل المحتوى",
  cockpit_report_progress_reading: "إعادة استخدام المحتوى الذي تم تحليله سابقًا",
  cockpit_report_progress_collecting: "جارٍ جمع رسائل البريد الإلكتروني والدردشات والمهام من مشاريعك",
  cockpit_report_progress_priorities: "جارٍ تجميع الأولويات والمواعيد النهائية والقرارات",
  cockpit_report_progress_queued: "جارٍ تجهيز التقرير",
  cockpit_report_creating_title: "يجري إعداد تقريرك اليومي",
  cockpit_report_progress_count_one: "تم تحليل عنصر واحد",
  cockpit_report_progress_count_many: "تم تحليل {{count}} عنصر",
  cockpit_report_progress_hint: "يستغرق هذا عادةً من دقيقة إلى دقيقتين – يمكنك متابعة استخدام لوحة القيادة في الأثناء.",
  cockpit_report_time_hint: "يُنشأ التقرير اليومي كل يوم في الساعة {{hour}}:00 لأكثر خمسة مشاريع نشاطًا.",
  room_overview_priorities_title: "الوضع الحالي والأولويات",
  room_overview_as_of: "اعتبارًا من {{time}}",
  cockpit_report_delete: "حذف التقرير اليومي",
  email_tag_daily_briefing: "التقرير اليومي",
  cockpit_report_unread: "جديد",
  cockpit_report_clear_project: "عرض جميع المشاريع",
  cockpit_filter_project: "المشروع",
  cockpit_filter_all_projects: "جميع المشاريع",
  cockpit_report_recreate: "إعادة إنشاء التقرير اليومي",
  cockpit_report_hide_previous: "إخفاء التقارير اليومية السابقة",
  cockpit_report_show_previous: "عرض التقارير اليومية السابقة",
  cockpit_report_room_empty: "لا يوجد تقرير يومي لهذا المشروع بعد",
  cockpit_report_empty: "لا يوجد تقرير يومي بعد",
  cockpit_report_room_empty_hint: "أنشئ تقريرًا يوميًا لهذا المشروع فقط.",
  cockpit_report_needs_mailbox: "اربط حساب بريد إلكتروني ليتمكن Kjuup من إنشاء تقرير يومي مع مهام تلقائية.",
  cockpit_report_create: "إنشاء تقرير يومي",
  cockpit_email_connect: "ربط البريد الإلكتروني",
  cockpit_email_none_title: "لا يوجد حساب بريد إلكتروني مرتبط بعد",
  cockpit_email_none_reports: "اربط صندوق بريدك ليتمكن Kjuup من إسناد الرسائل الواردة إلى مشاريعك وإنشاء تقارير يومية مع المهام.",
  cockpit_email_none_client: "اربط Gmail أو Outlook أو IMAP لقراءة رسائل البريد الإلكتروني وإسنادها والرد عليها مباشرةً في Kjuup.io.",
  cockpit_email_reports_title: "عميل البريد الحالي",
  cockpit_email_reports_text: "لا يوجد صندوق وارد في Kjuup.io · {{rooms}} مشاريع مع تقرير يومي في الساعة {{hour}}:00 · تُسند الرسائل الواردة إلى مشاريعك.",
  cockpit_email_reports_rooms: "إدارة المشاريع",
  cockpit_email_settings: "إعدادات البريد الإلكتروني",
  cockpit_email_error_title: "التحقق من الاتصال",
  cockpit_email_client_title: "صندوق الوارد متصل",
  cockpit_email_accounts_n: "تم ربط {{n}} حساب",
  cockpit_email_last_sync: "آخر مزامنة {{when}}",
  cockpit_email_report_at: "تقرير يومي في الساعة {{hour}}:00",
  cockpit_email_open_inbox: "فتح صندوق الوارد",
  cockpit_email_eyebrow: "بريد Kjuup",
  cockpit_email_accounts_label: "عناوين البريد الإلكتروني المرتبطة",
  email_folder_sent: "العناصر المرسلة",
  email_no_subject: "(بلا موضوع)",
  cockpit_email_detail_loading: "جارٍ تحميل البريد الإلكتروني …",
  cockpit_email_detail_failed: "تعذّر تحميل البريد الإلكتروني.",
  cockpit_email_detail_empty: "لا يحتوي هذا البريد الإلكتروني على نص.",
  cockpit_personal_settings: "الإعدادات الشخصية",
  cockpit_companies: "الشركات",
  cockpit_title: "لوحة القيادة",
  cockpit_back: "العودة إلى النظرة العامة",
  cockpit_day_overview: "يومك في لمحة",
  email_saved_to_project: "تم حفظ البريد الإلكتروني في المشروع",
  email_classify_need_project: "يرجى إدخال اسم المشروع",
  cockpit_email_deleted: "تم حذف البريد الإلكتروني",
  cockpit_email_sent_empty: "لا توجد رسائل مرسلة بعد.",
  cockpit_email_incoming_empty: "لا توجد رسائل واردة بعد.",
  cockpit_email_incoming_title: "رسائل البريد الإلكتروني",
  cockpit_email_incoming_sub: "أسند الرسائل الواردة والمرسلة إلى مشاريعك. يمكنك تعديل الإسناد هنا.",
  cockpit_email_incoming_unassigned_n: "{{n}} غير مُسندة",
  cockpit_email_folder_inbox: "صندوق الوارد",
  cockpit_email_folder_sent: "المرسلة",
  cockpit_email_open: "فتح البريد الإلكتروني",
  cockpit_email_incoming_suggested: "المقترح: {{room}}",
  cockpit_email_incoming_apply: "تطبيق",
  cockpit_email_incoming_adjust: "تعديل الإسناد",
  cockpit_email_incoming_saving: "جارٍ الحفظ …",
  cockpit_email_incoming_unassigned: "غير مُسند",
  cockpit_email_incoming_show_less: "عرض أقل",
  cockpit_email_incoming_show_all: "عرض الكل ({{n}})",
  cockpit_io_settings: "إعدادات Kjuup.io",
  cockpit_io_settings_sub: "الباقة والمقاعد وإسناد الموظفين والفوترة والفواتير.",
  products_coming_soon: "قريبًا",
  cockpit_upsell_io_title: "مكتبك الذي يفكر معك",
  cockpit_upsell_io_text: "اربط حسابات بريدك الإلكتروني بـ Kjuup. تُحفظ الرسائل والمرفقات والمراسلات تلقائيًا في المشروع المناسب، ويمكن تخزينها اختياريًا على خادمك. تحصل كل يوم على ملخص لجميع المشاريع مع النقاط الرئيسية من كل المحتوى، وتتزامن مهامك مع تقويمك أو تطبيق المهام لديك.",
  cockpit_upsell_io_soon_title: "غير متاح للحجز بعد",
  cockpit_upsell_io_soon_text: "سيتم إطلاق Kjuup.io قريبًا. اطلب المعلومات الآن – وسنُعلمك فور إمكانية حجز Kjuup.io.",
  cockpit_upsell_io_planned_price: "السعر المخطط",
  cockpit_upsell_io_cta_request: "طلب معلومات",
  kjuup_plus_abo_per_year: "/ سنة",
  kjuup_plus_abo_per_month: "/ شهر",
  kjuup_plus_abo_status_active: "نشط",
  kjuup_plus_abo_status_requested: "تم طلب الإلغاء",
  kjuup_plus_abo_status_past_due: "الدفع مستحق",
  kjuup_plus_abo_eyebrow: "Kjuup+ · الاشتراك",
  kjuup_plus_abo_title: "باقة Kjuup+",
  kjuup_plus_abo_seats_free_one: "مقعد واحد متبقٍ",
  kjuup_plus_abo_billing: "الفوترة",
  kjuup_plus_abo_yearly: "سنوي",
  kjuup_plus_abo_monthly: "شهري",
  kjuup_plus_abo_amount: "المبلغ",
  kjuup_plus_abo_ends: "ينتهي في",
  kjuup_plus_abo_renews: "التجديد التالي",
  kjuup_plus_abo_next_invoice: "الفاتورة التالية",
  kjuup_plus_abo_intro: "سعر تمهيدي",
  kjuup_plus_abo_pending_tier: "اعتبارًا من التجديد التالي",
  kjuup_plus_abo_manual: "Kjuup+ مفعّل لشركتك بموجب اتفاقية خاصة.",
  kjuup_plus_abo_invoices: "الفواتير",
  kjuup_plus_abo_invoice_paid: "مدفوعة",
  kjuup_plus_abo_invoice_view: "عرض",
  kjuup_plus_abo_invoices_less: "عرض أقل",
  kjuup_plus_abo_member_hint: "تتم إدارة الفوترة والإلغاء من قِبل مديري شركتك.",
  kjuup_plus_abo_withdraw: "سحب الطلب",
  kjuup_plus_abo_cancel_note: "السبب (اختياري)",
  kjuup_plus_abo_cancel_send: "طلب الإلغاء",
  kjuup_plus_abo_cancel: "إلغاء الاشتراك",
  cockpit_upsell_plus_f1: "إدارة نشاط التواصل لجميع موظفيك",
  cockpit_upsell_plus_f2: "إبلاغ مجموعات مستخدمين محددة داخل الشركة",
  cockpit_upsell_plus_f3: "حفظ الدردشات الجماعية الداخلية",
  cockpit_upsell_plus_when_yearly: "عند الدفع سنويًا",
  cockpit_upsell_plus_size_small: "1–50 موظفًا",
  cockpit_upsell_plus_size_large: "51–200 موظف",
  cockpit_upsell_plus_title: "Kjuup+ للشركات",
  cockpit_upsell_plus_text: "أدر الموظفين وصلاحيات الكتابة وتواصل الشركة في مكان واحد. تبقى القنوات الداخلية ضمن فريقك، وتربطك القنوات الخارجية بشركاء المشروع، ويمكنك الوصول إلى مجموعات محددة مباشرةً. إلى جانب Kjuup+، يمكنك حجز وصول Kjuup.io لمجموعات الموظفين. يمكن الجمع بين Kjuup+ وKjuup.io.",
  cockpit_upsell_plus_size: "حجم الشركة",
  cockpit_upsell_plus_billing: "الفوترة",
  cockpit_upsell_plus_per_company: "/ شركة · شهريًا دون ضريبة القيمة المضافة",
  cockpit_upsell_plus_onboarding: "تعتمد تكاليف التهيئة والتعريف على حجم الشركة",
  cockpit_upsell_plus_larger: "الأسعار للشركات الأكبر عند الطلب",
  cockpit_upsell_plus_cta: "استفسر دون التزام",
  cockpit_kpi_deadlines_tasks: "المواعيد النهائية والمهام",
  cockpit_kpi_appointments: "المواعيد",
  cockpit_room_admin: "إدارة المشاريع والدردشات",
  cockpit_room_admin_sub: "جميع مشاريع الشركة مع الأعضاء والوسائط والدردشات.",
  pro_todo_not_found: "لم تعد هذه المهمة متاحة.",
  cockpit_chip_overdue: "متأخرة",
  cockpit_chip_today: "اليوم",
  cockpit_calendar_week: "الأسبوع {{week}}",
  cockpit_prev_week: "الأسبوع السابق",
  cockpit_next_week: "الأسبوع التالي",
  cockpit_chip_requested: "مطلوبة",
  cockpit_todo_due: "الموعد النهائي {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "من {{name}}",
  cockpit_todo_since: "منذ {{when}}",
  cockpit_todo_no_date: "بلا تاريخ",
  cockpit_todo_mark_done: "وضع علامة كمنجزة",
  cockpit_my_tasks_title: "مهامي",
  cockpit_today_tasks_group: "مهام اليوم",
  cockpit_assign_none: "لم يتم إسناد أحد",
  no_project_found: "لم يتم العثور على أي مشروع",
  cockpit_row_more_actions: "مزيد من الإجراءات",
  needs_date: "تحديد تاريخ",
  cockpit_assign_proposal: "تم التعرّف على {{name}} – إسناد؟",
  cockpit_assign_proposal_confirm: "إسناد",
  cockpit_assign_proposal_dismiss: "تجاهل",
  cockpit_priority_date: "التاريخ",
  todo_calendar_add: "إضافة إلى التقويم",
  todo_calendar_remove: "إزالة من التقويم",
  cockpit_todo_change_project: "تغيير المشروع",
  cockpit_todo_set_date: "تحديد التاريخ",
  pro_todo_done_confirm: "هل تريد حقًا وضع علامة منجزة على هذه المهمة؟",
  cockpit_task_delete_failed: "تعذّر حذف المهمة.",
  cockpit_setup_title: "إكمال الإعداد",
  cockpit_setup_text: "قرّر ما إذا كنت تريد استخدام الدردشات، وما إذا كان Kjuup.io سيعمل كعميل بريد إلكتروني أم مع المشاريع والتقارير اليومية فقط.",
  cockpit_setup_cta: "أعدّ الآن",
  cockpit_group_tasks: "المواعيد النهائية والمهام",
  cockpit_group_appointments: "المواعيد",
  cockpit_report_no_activity: "لم تكن هناك رسائل أو بريد إلكتروني جديد في هذا المشروع خلال آخر 24 ساعة.",
  cockpit_report_room_unavailable: "هذا المشروع غير متاح.",
  cockpit_report_create_failed: "تعذّر إنشاء التقرير اليومي.",
  cockpit_report_created: "تم إنشاء التقرير اليومي",
  addon_enable_confirm: "تفعيل الإضافة؟",
  addon_enable: "تفعيل",
  addon_enabled: "تم تفعيل الإضافة",
  nav_email: "البريد الإلكتروني",
  nav_my_cockpit: "لوحة قيادتي",
  nav_news: "الأخبار",
  nav_recommend: "أوصِ",
  pro_todo_status_done: "منجزة",
  pro_todo_status_open: "مفتوحة",
  v2_todo_remove: "إزالة",
  pro_todo_search_people: "بحث عن أشخاص",
  pro_todo_clear: "مسح",
  pro_todo_assigned: "(مُسندة)",
  pro_todo_no_people: "لم يتم العثور على أشخاص",
  pro_todo_search_rooms: "بحث عن مشاريع",
  pro_todo_no_rooms_match: "لا توجد مشاريع تطابق «{{q}}»",
  pro_todo_no_rooms: "لم يتم العثور على مشاريع",
  pro_todo_activity: "النشاط",
  pro_todo_show_less: "عرض أقل",
  pro_todo_show_all: "عرض الكل ({{n}})",
  pro_todo_due: "الموعد النهائي",
  pro_todo_room: "المشروع",
  pro_todo_select_room: "اختيار المشروع",
  pro_todo_status: "الحالة",
  pro_todo_more: "المزيد",
  pro_todo_edit_title: "تعديل المهمة",
  pro_todo_description: "الوصف",
  pro_todo_created_by: "أنشأها",
  pro_todo_chat: "الدردشة",
  navigate_to_source: "الانتقال إلى المصدر",
  todo_calendar_connect_title: "لا يوجد تقويم متصل",
  todo_calendar_connect_body_web: "اربط تقويمًا في إعدادات مزامنة التقويم لإضافة المهام إليه.",
  todo_calendar_connect: "ربط",
  todo_calendar_removed: "تمت الإزالة من تقويمك",
  todo_calendar_added_later: "تمت الإضافة. تعذّر الوصول إلى تقويمك؛ سيعيد Kjuup المحاولة لاحقًا.",
  todo_calendar_added: "تمت الإضافة إلى تقويمك",
  todo_calendar_no_date: "لا يمكن إضافة سوى مهمة ذات تاريخ إلى التقويم.",
  todo_calendar_failed: "تعذّر تحديث تقويمك. يرجى المحاولة مرة أخرى.",
  todo_calendar_date_title: "لا يوجد تاريخ بعد",
  todo_calendar_date_save: "حدّد التاريخ وأضف",
  todo_calendar_date_body_web: "هذه المهمة المحفوظة بلا تاريخ بعد. حدّد تاريخًا لإضافتها إلى تقويمك.",
  kjuup_io_setup_saved: "تم حفظ الإعداد",
  kjuup_io_setup_step: "الخطوة",
  kjuup_io_setup_chats_title: "هل تريد استخدام الدردشات؟",
  kjuup_io_setup_email_title: "أين تريد قراءة رسائل بريدك الإلكتروني؟",
  kjuup_io_setup_chats_sub: "الدردشات مع الزملاء وشركاء المشروع اختيارية. يمكنك إظهارها أو إخفاءها على لوحة القيادة في أي وقت.",
  kjuup_io_setup_email_sub: "هذا الخيار يحدد فقط ما إذا كنت تستخدم عميل بريد في Kjuup أم تواصل استخدام برنامج بريدك الحالي، مثل Outlook أو غيره. يمكنك التبديل لاحقًا.",
  kjuup_io_setup_chats_yes: "نعم، أظهر الدردشات",
  kjuup_io_setup_chats_yes_text: "تتضمن الرسائل الدردشات والبريد الإلكتروني. تحتوي المشاريع على دردشات جماعية لجميع المشاركين.",
  kjuup_io_setup_chats_no: "لا، أعمل بدون دردشات",
  kjuup_io_setup_chats_no_text: "الدردشات مخفية. تصبح «الرسائل» «البريد الإلكتروني»؛ وتبقى المشاريع والمهام والتقارير اليومية.",
  kjuup_io_setup_email_client: "عميل البريد في Kjuup",
  kjuup_io_setup_email_client_text: "اقرأ رسائل البريد الإلكتروني وردّ عليها مباشرةً في Kjuup.",
  kjuup_io_setup_email_reports: "عميل البريد الحالي",
  kjuup_io_setup_email_reports_text: "واصل القراءة والرد في برنامجك الحالي، مثل Outlook أو غيره.",
  kjuup_io_setup_skip: "لاحقًا",
  next: "التالي",
  kjuup_io_setup_finish: "إنهاء الإعداد",
  today_label: "اليوم",
  tomorrow_label: "غدًا",
  cockpit_todo_overdue: "متأخرة",
  cockpit_report_management_fazit: "ملخص الإدارة",
  cockpit_todo_appointment: "موعد",
  cockpit_todo_deadline: "الموعد النهائي",
  cockpit_todo_deadline_define: "تحديد الموعد النهائي",
  pro_todo_status_acknowledged: "تم التأكيد",
  pro_todo_responsible: "المسؤول",
  pro_todo_notice_confirmed: "تم التأكيد في الدردشة",
  pro_todo_notice_sent_at: "تم إرسال الرسالة",
  pro_todo_notice_again: "إعادة إرسال الرسالة",
  pro_todo_notice_send: "إبلاغ عبر رسالة Kjuup",
  pro_todo_add_assignee: "إضافة",
  pro_todo_edit: "تعديل",
  pro_todo_change_room: "تغيير المشروع",
  pro_todo_due_on: "الموعد النهائي في",
  pro_todo_edit_due: "تعديل الموعد النهائي",
  pro_todo_no_date: "بلا تاريخ",
  pro_todo_edit_description: "تعديل الوصف",
  pro_todo_no_description: "لا يوجد وصف بعد",
  pro_todo_title_label: "العنوان",
  pro_todo_title_placeholder: "أدخل العنوان...",
  pro_todo_task: "المهمة",
  pro_todo_what: "ما الذي يجب فعله؟",
  pro_todo_source_email: "البريد الإلكتروني",
  pro_todo_sources: "المصادر",
  previous: "السابق",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (حتى {max} موظف)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (حتى {max} موظف)",
  kjuup_plus_abo_status_ends: "ينتهي في {date}",
  kjuup_plus_abo_seats_over: "أكثر من {max} موظف – سيتواصل معك فريق Kjuup بعرض مخصص.",
  kjuup_plus_abo_seats_next: "إذا انضم مزيد من الموظفين، تنتقل الباقة تلقائيًا إلى {next} (بحساب تناسبي).",
  kjuup_plus_abo_seats_used: "{used} من {total} مقاعد مستخدمة",
  kjuup_plus_abo_seats_free: "{count} مقاعد متبقية",
  kjuup_plus_abo_intro_until: "حتى {date}",
  kjuup_plus_abo_invoice_open: "مفتوحة · مستحقة في {date}",
  kjuup_plus_abo_invoices_all: "عرض الكل ({count})",
  kjuup_plus_abo_requested_hint: "تم طلب الإلغاء في {date}. سيؤكده Kjuup في نهاية مدة الاشتراك ({end}).",
  kjuup_plus_abo_cancel_hint: "يراجع Kjuup طلبك ويؤكد الإلغاء في نهاية مدة الاشتراك ({end}). يبقى Kjuup+ نشطًا حتى ذلك الحين.",
  kjuup_plus_abo_withdrawn: "تم سحب طلب الإلغاء",
  kjuup_plus_abo_requested: "تم طلب الإلغاء",
  cockpit_upsell_plus_intro_hint: "أول {months} أشهر، ثم {price}",
  cockpit_upsell_plus_badge: "سعر تمهيدي لمدة {months} أشهر",
  calendar_syncing: "جارٍ التحديث من التقويم…",
  calendar_sync_up_to_date: "التقويم محدَّث",
  calendar_sync_failed: "فشلت المزامنة",
  delete_multiple_tasks_confirm: "هل أنت متأكد أنك تريد حذف {count} من ToDo؟",
  todos_deleted_count: "تم حذف {count} من ToDo",
  todos_deleted_partial: "تم حذف {ok} من ToDo، فشل {fail}",
  todo_unknown: "غير معروف",
  todo_created_from_message: "تم إنشاء مهمة من هذه الرسالة",
  kjuup_io_todo_calendar_trial_ended_note: "مزامنة التقويم · اشتراك",
  kjuup_io_todo_calendar_nudge: "مزامنة هذه ToDo مع تقويمك؟",
  kjuup_io_todo_calendar_nudge_cta: "تفعيل Kjuup.io",
  todo_confirmed: "ToDo مؤكد",
  pro_todo_bulk_delete_title: "حذف {{n}} مهام؟",
  pro_todo_previous_none_own: "المهام المتأخرة أُسندت إليك من قِبل آخرين ولا يمكن حذفها إلا من قِبلهم.",
  pro_todo_previous_none: "لا توجد مهام متأخرة",
  pro_todo_previous_title: "حذف {{n}} مهام متأخرة؟",
  pro_todo_previous_text: "سيتم حذف جميع مهامك المفتوحة من الأيام السابقة.",
  pro_todo_previous_skipped: "ستبقى {{n}} مهام أسندها إليك آخرون.",
  unassign_task_confirm: "هل تريد إلغاء تعيينك من هذه المهمة؟",
  unassign_label: "إلغاء التعيين",
  pro_todo_delete_title: "حذف المهمة",
  pro_todo_today: "اليوم",
  pro_todo_yesterday: "أمس",
  pro_todo_since_yesterday: "منذ الأمس",
  pro_todo_mark_open: "تعليم كمفتوحة",
  verify_completion: "تحقق",
  new_label: "جديد",
  bookmarked_no_mylist: "لا يمكن إضافة المهام المحفوظة إلى قائمتي",
  delete_only_own: "يمكنك حذف المهام التي أنشأتها بنفسك فقط",
  todo_clear_all: "مسح الكل",
  pro_todo_of_completed: "تم إنجاز {{done}} من {{total}}",
  pro_todo_pick_date: "اختيار تاريخ",
  pro_todo_show_day: "عرض اليوم",
  todo_adjust_list: "تعديل القائمة",
  pro_todo_section_upcoming: "قادمة",
  pro_todo_section_done: "مكتملة",
  pro_todo_room_empty_today: "لا توجد مهام لهذا اليوم في هذا المشروع",
  pro_todo_room_empty_day: "لا توجد مهام في هذا اليوم في هذا المشروع",
  pro_todo_delete_previous: "حذف الكل",
  todo_my_list_empty: "يومك فارغ",
  todo_my_list_empty_hint: "انقر على «تعديل القائمة» لإضافة مهام",
  pro_todo_empty_title: "لا شيء هنا",
  pro_todo_empty_hint: "لا توجد مهام تطابق هذا العرض.",
  pro_todo_selected: "تم تحديد {{n}}",
  delete_selected_count: "حذف ({count})",
  pro_todo_adjust_done: "تم",
  pro_todo_deleting: "جارٍ الحذف...",
  pro_todo_reopen: "إعادة فتح المهمة",
  pro_todo_step_done: "منجزة",
  move_back_in_progress: "العودة إلى قيد التنفيذ",
  pro_todo_mark_not_started: "وضع علامة لم تبدأ",
  back_into_in_progress: "العودة إلى قيد التنفيذ",
  pro_todo_mark_in_progress: "وضع علامة قيد التنفيذ",
  unassign_todo: "إلغاء تعيين ToDo",
  pro_todo_open_room: "فتح المشروع",
  pro_todo_new_task: "مهمة جديدة",
  select_user_back_to_in_progress: "اختر المستخدم لإعادته إلى قيد التنفيذ",
  cockpit_email_accounts_n_many: "تم ربط {{n}} حسابات",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "جهات اتصال Kjuup",
  combined_tab_teams: "جهات اتصال Teams",
  combined_bridge_failed: "تعذّر إنشاء نسخة Teams.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "جهات اتصال Kjuup وTeams: سيتم إنشاء مجموعة جديدة تظهر أيضًا في Microsoft Teams.",
  teams_new_chat_title: "دردشة Teams جديدة",
  teams_new_chat_topic: "اسم المجموعة (اختياري)",
  teams_new_chat_start: "بدء الدردشة",
  teams_new_chat_creating: "جارٍ إنشاء الدردشة…",
  teams_new_chat_forbidden: "لا يسمح Microsoft Teams بهذه الدردشة (مثل شخص من خارج مؤسستك أو سياسة لقسم تقنية المعلومات لديك).",
  teams_new_chat_too_many: "عدد كبير جدًا من الأشخاص لدردشة واحدة.",
  teams_new_chat_type_hint: "اكتب اسمًا للبحث في مؤسستك.",
  teams_new_chat_directory_forbidden: "لا تسمح مؤسستك بالبحث في الدليل. يتم عرض الأشخاص من دردشات Teams فقط.",
  teams_new_chat_account: "الحساب",
};
